import * as React from 'react';
const TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;